// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-topbar .topbar-left {
  gap: 14px;
}
.ultimate-security-topbar .topbar-left .dashboard-link {
  margin-left: 20px;
}
.ultimate-security-topbar .topbar-left li {
  list-style-type: none;
}
.ultimate-security-topbar .topbar-left li a {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
.ultimate-security-topbar .topbar-left li a:focus {
  box-shadow: unset;
  outline: unset;
}
.ultimate-security-topbar .topbar-right .header-logos {
  padding-right: 16px;
}
.ultimate-security-topbar .topbar-right .header-logos a:focus {
  box-shadow: unset;
  outline: unset;
}
.ultimate-security-topbar .topbar-right .topbar-right-unit {
  display: flex;
  align-items: center;
}
.ultimate-security-topbar .topbar-right .topbar-right-unit:not(:first-child)::before {
  content: "";
  width: 2px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.5);
  display: block;
  margin-left: 18px;
  margin-right: 18px;
}`, "",{"version":3,"sources":["webpack://./src/layouts/Header/Header.scss"],"names":[],"mappings":"AACC;EACC,SAAA;AAAF;AACQ;EACI,iBAAA;AACZ;AACE;EACC,qBAAA;AACH;AAAG;EACa,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACZ,WAAA;EACA,eAAA;EACY,gBAAA;EACZ,iBAAA;AAEJ;AAAI;EACC,iBAAA;EACA,cAAA;AAEL;AAIE;EACC,mBAAA;AAFH;AAII;EACC,iBAAA;EACA,cAAA;AAFL;AAOE;EACC,aAAA;EACA,mBAAA;AALH;AAOG;EACC,WAAA;EACA,UAAA;EACA,YAAA;EACA,0CAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AALJ","sourcesContent":[".ultimate-security-topbar {\n\t.topbar-left {\n\t\tgap: 14px;\n        .dashboard-link{\n            margin-left: 20px;\n        }\n\t\tli {\n\t\t\tlist-style-type: none;\n\t\t\ta {\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                text-decoration: none;\n\t\t\t\tcolor: #fff;\n\t\t\t\tfont-size: 16px;\n                font-weight: 600;\n\t\t\t\tline-height: 24px;\n\t\t\t\t\n\t\t\t\t&:focus{\n\t\t\t\t\tbox-shadow: unset;\n\t\t\t\t\toutline: unset;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.topbar-right {\n\t\t.header-logos {\n\t\t\tpadding-right: 16px;\n\t\t\ta{\n\t\t\t\t&:focus{\n\t\t\t\t\tbox-shadow: unset;\n\t\t\t\t\toutline: unset;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\t\n\t\t}\n\t\t.topbar-right-unit {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t&:not(:first-child)::before {\n\t\t\t\tcontent: \"\";\n\t\t\t\twidth: 2px;\n\t\t\t\theight: 20px;\n\t\t\t\tbackground-color: rgba(255, 255, 255, 0.5);\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-left: 18px;\n\t\t\t\tmargin-right: 18px;\n\t\t\t}\n\t\t}\n\t}\n\t\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
